import axios from "axios";
import { sanitizeAndStrip } from "./sanitize";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 25000 });

export const getProducts = async (params = {}) => {
  const { data } = await client.get("/products", { params });
  return data;
};

export const getProductsPage = async (params = {}) => {
  const { data } = await client.get("/products-page", { params });
  return data;
};

export const getProduct = async (id) => {
  const { data } = await client.get(`/products/${id}`);
  return data;
};

export const getProductsByIds = async (ids) => {
  if (!ids?.length) return [];
  const { data } = await client.get("/products/by-ids", { params: { ids: ids.join(",") } });
  return data;
};

export const getCategories = async () => {
  const { data } = await client.get("/categories");
  return data;
};

export const createCheckout = async (payload) => {
  const { data } = await client.post("/orders/checkout", payload);
  return data;
};

export const getObiReview = async (productId, lang = "it") => {
  const { data } = await client.get(`/obi-review/${productId}`, { params: { lang } });
  return data;
};

export const getGpsrForBrand = async (brandSlug, brandName = "") => {
  const { data } = await client.get(`/gpsr/${encodeURIComponent(brandSlug)}`, {
    params: { brand_name: brandName },
  });
  return data;
};

export const getObiCategory = async (categoryId, lang = "it") => {
  const { data } = await client.get(`/obi-category/${categoryId}`, { params: { lang } });
  return data;
};

export const sendObiChat = async (sessionId, message, lang = "it") => {
  const { data } = await client.post("/obi-chat", { session_id: sessionId, message, lang });
  return data;
};

export const giftFinder = async ({ occasion, age, budget, taste, lang = "it" }) => {
  const { data } = await client.post("/gift-finder", { occasion, age, budget, taste, lang });
  return data;
};

export const stripHtml = (html) => sanitizeAndStrip(html);

export const formatPrice = (val, currency = "€") => {
  const n = parseFloat(val || 0);
  if (Number.isNaN(n)) return `${currency} 0,00`;
  return `${currency} ${n.toFixed(2).replace(".", ",")}`;
};
